export * from "../../../../src/auth/domain/model/Action.js";
export * from "../../../../src/auth/domain/model/Authorizer.js";
export * from "../../../../src/auth/domain/model/EndpointResourceActions.js";
export * from "../../../../src/auth/domain/model/Entity.js";
export * from "../../../../src/auth/domain/model/OneMapApiEvent.js";

export {
  ENDPOINT_RESOURCE_ACTIONS_TABLE_NAME,
  ENDPOINT_RESOURCE_ACTIONS_VERSION_METADATA_PK_VALUE,
  ENDPOINT_RESOURCE_ACTIONS_TABLE_INDEX_NAME_CURRENT_VERSION,
} from "../../../../src/auth/data/constants.js";
/**
 * Lambda function name for the authorizer. Must stay in sync with
 * `infrastructure/constants.ts:AUTHORIZER_LAMBDA_NAME`.
 *
 * Transitional `onemap-cloud-*` namespace; rename back to `onemap-auth-authorizer`
 * once the legacy onemap-auth stack is destroyed post-cutover.
 */
export const AUTHORIZER_LAMBDA_FUNCTION_NAME = "onemap-cloud-auth-authorizer";
